import { useState } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Products />
      <Footer />
    </div>
  );
}
